import type React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';

export const ImprintPage: React.FC = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#080810',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div style={{ maxWidth: 800, margin: '0 auto', padding: '60px 20px', flex: 1 }}>
        <Link
          to="/"
          style={{
            color: '#00ff00',
            textDecoration: 'none',
            fontVariantCaps: 'all-petite-caps',
            letterSpacing: 1,
            fontWeight: 600,
          }}
        >
          ← Back to Home
        </Link>
        <h1
          style={{
            marginTop: 24,
            fontVariantCaps: 'all-petite-caps',
            fontSize: '2.5rem',
            color: '#ff2d95',
          }}
        >
          Legal Notice / Impressum
        </h1>

        <section style={{ marginTop: 32, lineHeight: 1.7, color: 'rgba(255,255,255,0.85)' }}>
          <h2 style={{ fontSize: '1.3rem', color: '#00ff00', fontVariantCaps: 'all-petite-caps' }}>
            Information according to § 5 TMG
          </h2>
          <p>
            Fabian Althaus
            <br />
            alias Joev Noise
            <br />
            Berlin, Germany
            <br />
            Email: f.althaus [at] joev.de
            <br />
            Website:{' '}
            <a
              href="https://fabianalthaus.de"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#00ff00' }}
            >
              fabianalthaus.de
            </a>
          </p>

          <h2
            style={{
              fontSize: '1.3rem',
              color: '#00ff00',
              fontVariantCaps: 'all-petite-caps',
              marginTop: 28,
            }}
          >
            Responsible for content according to § 55 Abs. 2 RStV
          </h2>
          <p>
            Fabian Althaus
            <br />
            Berlin, Germany
          </p>

          <h2
            style={{
              fontSize: '1.3rem',
              color: '#00ff00',
              fontVariantCaps: 'all-petite-caps',
              marginTop: 28,
            }}
          >
            Copyright &amp; Intellectual Property
          </h2>
          <p>
            All music tracks, album artworks, writings, and multimedia assets published on this site
            are intellectual property of Fabian Althaus (Joev Noise) unless indicated otherwise. Any
            reproduction, distribution, or public performance without written consent is strictly
            prohibited.
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default ImprintPage;
